import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import {Observable} from 'rxjs';

// Garde historique: vérifie que l'utilisateur est connecté
@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const isLoggedIn = localStorage.getItem('token') !== undefined && localStorage.getItem('token') !== null;

    if (!isLoggedIn) {
       this.router.navigate(['/login']);
    }
    return isLoggedIn;
  }
}

// Alias explicite pour les routes: même logique que AuthGuard
@Injectable({ providedIn: 'root' })
export class UserGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const token = localStorage.getItem('token');
    if (!token) {
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }
}

// Garde Admin: nécessite être connecté ET admin
@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const token = localStorage.getItem('token');
    if (!token) {
      this.router.navigate(['/login']);
      return false;
    }

    const isAdmin = localStorage.getItem('isAdmin') === 'true';
    if (!isAdmin) {
      this.router.navigate(['/unauthorized']);
      return false;
    }

    return true;
  }
}
